import { getFullUrl } from 'hubspot-url-utils';
import { BASE_AVATAR_SIZE_PARAMS } from '../../constants/avatars';
import baseHttpClient from '../../utils/apiClient';
import captureException from '../../utils/captureException';
export const getAvatars = data => baseHttpClient.post(`${getFullUrl('app-api')}/avatars/v1/avatars/batch`, {
  data: Object.assign({
    sizeParams: BASE_AVATAR_SIZE_PARAMS
  }, data)
}).catch(captureException);